import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import type { ProductReviewListModel } from 'autogen/swagger/all';
import { _LoginInfo } from 'autogen/swagger/all';
import { ReviewsDisabledText } from 'autogen/translation-keys/trans-website-productreview-list';
import { Button } from 'components/Button';
import LinkButton from 'components/Button/LinkActionButton';
import useLoginInfoQuickView from 'components/login/shared/hooks/useLoginInfoQuickView';
import { toHtmlContent } from 'modules/helpers/strings';
import { getTrackingClass } from 'modules/tracking/clickTracking';
import { breakpoint, sizes } from 'variables';

const Wrapper = styled.div``;

const ReviewButtonStyle = css`
    width: 100%;

    ${breakpoint.up(sizes.md)} {
        width: 100%;
    }
`;

const StyledLinkButton = styled(LinkButton)`
    ${ReviewButtonStyle}
`;

const StyledButton = styled(Button)`
    ${ReviewButtonStyle}
`;

const ReviewsDisabled = styled.div``;

interface IWriteReviewButtonProps {
    model: ProductReviewListModel;
}

export const WriteReviewButton = (props: IWriteReviewButtonProps): JSX.Element | null => {
    const { model, ...rest } = props;
    const { productId, reviewButton, isWriteProductReviewEnabled, userHasReviewedProduct } = model;
    const { t } = useTranslation();
    const {
        link: {
            text,
            link: { linkAction }
        },
        loginRequest: {
            loginState: { isLoggedIn }
        }
    } = reviewButton;

    const [, toggle] = useLoginInfoQuickView();

    function getLoginInfo() {
        _LoginInfo({
            productId,
            infoType: 'WriteReview',
            level: 'Soft',
            mode: 'Standard',
            returnUrl: window.location.pathname
        }).then((loginInfo) => {
            toggle({ isOpen: true, loginInfo });
        });
    }

    const onReviewButtonClick = async (): Promise<void> => {
        getLoginInfo();
    };

    let buttonContent;
    if (userHasReviewedProduct) {
        buttonContent = null;
    } else if (isWriteProductReviewEnabled && isLoggedIn) {
        buttonContent = (
            <StyledLinkButton
                action={linkAction}
                variant="primary"
                className={getTrackingClass('reviews', 'writeReview')}
            >
                {text}
            </StyledLinkButton>
        );
    } else if (isWriteProductReviewEnabled) {
        buttonContent = (
            <StyledButton variant="primary" onClick={onReviewButtonClick}>
                {text}
            </StyledButton>
        );
    } else {
        buttonContent = toHtmlContent(t(ReviewsDisabledText), ReviewsDisabled);
    }

    return !userHasReviewedProduct ? <Wrapper {...rest}>{buttonContent}</Wrapper> : null;
};

export default WriteReviewButton;
